import { render, staticRenderFns } from "./diffPressure.vue?vue&type=template&id=27257145&scoped=true"
import script from "./diffPressure.vue?vue&type=script&lang=js"
export * from "./diffPressure.vue?vue&type=script&lang=js"
import style0 from "./diffPressure.vue?vue&type=style&index=0&id=27257145&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27257145",
  null
  
)

export default component.exports